import React from "react";
import "./comment.scss";

const Comment = () => {
  return (
   <>
    <section id="leave-comment-wrapper">
      <div className="comment">
        <span>Leave a comment</span>
      </div>
      <form action="" className="comment-form">
        <div className="row">
          <div className="col-12">
            <label>Comment *</label>
            <textarea rows="7"></textarea>
          </div>
          <div className="col-md-4">
            <label>Name *</label>
            <input type="text" />
          </div>
          <div className="col-md-4">
            <label>Email *</label>
            <input type="email" />
          </div>
          <div className="col-md-4">
            <label>Website *</label>
            <input type="text" />
          </div>
          <div className="col-md-3 col-12">
            <button><span>Post Comment</span></button>
          </div>
        </div>
      </form>
    </section>
   </> 
   
  );
};

export default Comment;
